import { Context as ResponsiveContext } from 'react-responsive';

import type { Repub } from '@cx-modules/constants';
import type { DeviceType } from '@cx-modules/types';

import { breakpoints } from '~/react-utils/breakpoints';

import BottomNavigation from './lib/components/bottom-navigation/bottom-navigation';
import Header from './lib/components/header/header-container';
import type INav from './lib/interfaces/config/nav';

export interface IProps {
	deviceType: DeviceType;
	navData: INav;
	repub: Repub;
	resourcesUrl: string;
}

function HeaderWrapper({ deviceType, navData, repub, resourcesUrl }: IProps) {
	const isoRender = (
		<>
			<Header navData={navData} repub={repub} resourcesUrl={resourcesUrl} />
			<BottomNavigation navData={navData} repub={repub} />
		</>
	);

	if (typeof window !== 'undefined') {
		return isoRender;
	}

	const deviceWidth =
		deviceType === 'MOBILE'
			? breakpoints.phoneSm
			: deviceType === 'TABLET'
				? breakpoints.tablet
				: breakpoints.desktop;

	return (
		<ResponsiveContext.Provider value={{ width: deviceWidth }}>
			{isoRender}
		</ResponsiveContext.Provider>
	);
}

export default HeaderWrapper;
